<h1>{{ 'account.update_password.change_your_password.heading' | translate }}</h1>

<ish-error-message [error]="error$ | async" />

<div class="row">
  <div class="col-md-10 col-lg-8 col-xl-6">
    <ish-update-password-form (submitPassword)="requestPasswordChange($event)" />
  </div>
</div>

<ish-loading *ngIf="loading$ | async" />
